import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatKeysModal } from '@/core/chat/export';
import { MenuList } from '@/shared/components/export';
import '@/shared/theme/navbar-buttons.scss';
import { useUserMenuItems } from '@/app/dashboard/hooks/use-user-menu-items';

export default function DashboardUserMenu({
  className,
  notificationSoundOn,
  setNotificationSoundOn,
}: {
  className?: string;
  notificationSoundOn: boolean;
  setNotificationSoundOn: (on: boolean) => void;
}) {
  const { items, showChatKeysModal, setShowChatKeysModal } = useUserMenuItems({
    notificationSoundOn,
    setNotificationSoundOn,
  });

  return (
    <>
      <MenuList
        trigger={
          <span className={'fw-bold'}>
            <FontAwesomeIcon icon={faUser} style={{ fontSize: '1.15em' }} />
          </span>
        }
        toggleClassName={`btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square-wide dropdown-toggle${className ? ` ${className}` : ''}`}
        align="right"
        items={items}
        elevated
      />
      <ChatKeysModal
        showChatKeysModal={showChatKeysModal}
        setShowChatKeysModal={setShowChatKeysModal}
      />
    </>
  );
}
